import type { NextPage } from 'next';
import Head from 'next/head';
import styled from '@emotion/styled';

// 다국어 지원
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import Title from '@components/_atoms/Title';
import LoginContent from '@components/_templates/auth/LoginContent';

// constants
import { MOBILE_MODE } from '@constants/size';

const LoginWrapper = styled.div`
  width: 100%;
  max-width: 344px;
  padding: 110px 0;
  margin: 0 auto;

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 80px;

  @media ${MOBILE_MODE} {
    margin-bottom: 56px;
  }
`;

const Login: NextPage = () => {
  const { t } = useTranslation('auth');

  return (
    <>
      <Head>
        <title>{t('login.meta-title')}</title>
        <meta name="title" content={t('login.meta-title')} />
      </Head>
      <DefaultLayout>
        <LoginWrapper>
          <TitleWrapper>
            <Title content={t('login.title')} />
          </TitleWrapper>

          {/* Login Content */}
          <LoginContent />
          {/* Login Content end */}
        </LoginWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['auth', 'common', 'component'])),
  },
});

export default Login;
